(() => {
  'use strict';
  const one = (selector) => document.querySelector(selector);
  const all = (selector) => [...document.querySelectorAll(selector)];
  const menu = one('[data-action="menu"]');
  const nav = one('.mobile-nav');
  menu?.addEventListener('click', () => {
    nav.hidden = !nav.hidden;
    menu.setAttribute('aria-expanded', String(!nav.hidden));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && nav && !nav.hidden) {
      nav.hidden = true;
      menu.setAttribute('aria-expanded', 'false');
      menu.focus();
    }
  });
  all('.desktop-nav a, .mobile-nav a').forEach(link => {
    if (link.pathname === location.pathname) link.setAttribute('aria-current', 'page');
  });
  const categories = {'Meat':'beef-meat','Farm Store':'farm-store','Skincare':'skincare','Pantry':'pantry','Home & Body':'nontoxic-home','Wellness':'functional-foods','Pets':'pets','Plants':'no-discount-live-plants'};
  const params = new URLSearchParams(location.search);
  const category = params.get('category');
  if (/\/collections\/all\/?$/.test(location.pathname) && categories[category]) {
    params.delete('category');
    const query = params.toString();
    location.replace('/collections/' + categories[category] + (query ? '?' + query : ''));
  }
  all('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  const variantSelect = one('[data-native-variant]');
  const productForm = one('#citrus-product-form');
  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const add = one('[data-native-add]');
    if (add.disabled) return;
    const error = one('#cart-error');
    error.hidden = true;
    add.disabled = true;
    add.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', body:new FormData(productForm), headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || error.dataset.errorMessage);
      location.assign(root + 'cart');
    } catch (failure) {
      error.textContent = failure.message || error.dataset.errorMessage;
      error.hidden = false;
      add.disabled = false;
      add.removeAttribute('aria-busy');
    }
  });
  variantSelect?.addEventListener('change', () => {
    const selected = variantSelect.selectedOptions[0];
    one('#variant-price').textContent = selected.dataset.price;
    const add = one('[data-native-add]');
    const available = selected.dataset.available === 'true';
    add.disabled = !available;
    add.textContent = available ? add.dataset.addLabel + ' +' : add.dataset.soldLabel;
    const url = new URL(location.href);
    url.searchParams.set('variant', selected.value);
    history.replaceState(null, '', url);
  });
  all('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const image = one('#product-main-image');
    if (!image) return;
    image.src = button.dataset.gallerySrc;
    image.removeAttribute('srcset');
    all('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const shareData = {
    rear:{name:'Rear quarter',match:'Rear Quarter',hanging:160,take:112,freezer:'4–5',cuts:[0,4,11,11,3,2,0,25,9,0,0,7,6,34]},
    front:{name:'Front quarter',match:'Front Quarter',hanging:200,take:140,freezer:'5–6',cuts:[13,0,0,0,0,0,38,0,0,10,10,9,10,50]},
    half:{name:'Half share',match:'Half',hanging:360,take:252,freezer:'8–11',cuts:[13,4,11,11,3,2,38,25,9,10,10,16,16,84]},
    whole:{name:'Whole share',match:'Whole',hanging:720,take:504,freezer:'15–22',cuts:[26,8,22,22,6,4,76,50,18,20,20,32,32,168]}
  };
  const cutNames = ['Ribeye steaks / prime rib','Tenderloin / filet mignon','New York strip steaks','Top sirloin steaks','Tri-tip','Flank steak','Chuck roasts & steaks','Round roasts','Sirloin tip & rump roast','Brisket','Short ribs','Stew meat','Soup bones & shank','Ground beef'];
  const shareNode = one('#share-variants');
  if (!shareNode) return;
  let variants;
  try { variants = JSON.parse(shareNode.textContent); } catch { return; }
  const state = {program:'grass',size:'rear'};
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(cents / 100);
  const set = (selector, text) => { const el = one(selector); if (el) el.textContent = text; };
  function refresh() {
    const data = shareData[state.size];
    const program = state.program === 'organic' ? 'Certified Organic Grass Fed' : 'Grass-Fed';
    const variant = variants.find(item => item.title === program + ' / ' + data.match);
    set('[data-share-title]',data.name);
    set('[data-share-program]',state.program === 'organic' ? 'Certified organic grass-fed & grass-finished' : '100% grass-fed & grass-finished');
    set('[data-share-take]','~' + data.take + ' lb');
    set('[data-share-freezer]',data.freezer + ' cu ft');
    set('[data-share-hanging]',data.hanging + ' lb');
    set('[data-share-rate]',variant ? money(variant.price * 2 / data.hanging) : 'Call for pricing');
    set('[data-share-total]',variant ? money(variant.price * 2) : 'Call for pricing');
    set('[data-share-deposit]',variant ? money(variant.price) : 'Call for pricing');
    const reserve = one('#share-reserve');
    if (reserve) {
      reserve.href = variant?.available ? variant.url : 'tel:2099688435';
      reserve.textContent = variant?.available ? 'Reserve this share ↗' : 'Call to reserve this share ↗';
    }
    const list = one('#cut-list');
    if (list) {
      list.replaceChildren();
      const heading = document.createElement('h3');
      heading.className = 'cut-title'; heading.textContent = 'Inside your ' + data.name.toLowerCase(); list.append(heading);
      data.cuts.forEach((weight,index) => {
        if (!weight) return;
        const row = document.createElement('div'); row.className = 'cut-row';
        const label = document.createElement('span'); label.textContent = cutNames[index];
        const amount = document.createElement('strong'); amount.textContent = '~' + weight + ' lb';
        row.append(label,amount); list.append(row);
      });
      const total = document.createElement('div'); total.className='cut-row';
      const label = document.createElement('strong'); label.textContent='Estimated packaged total';
      const amount = document.createElement('strong'); amount.textContent='~' + data.take + ' lb';
      total.append(label,amount);list.append(total);
    }
  }
  all('[data-program], [data-size]').forEach(button => button.addEventListener('click', () => {
    const field = button.dataset.program ? 'program' : 'size';
    state[field] = button.dataset[field];
    all('[data-' + field + ']').forEach(b => b.setAttribute('aria-pressed',String(b.dataset[field] === state[field])));
    refresh();
  }));
  refresh();
})();
